import React, { useState } from "react";
import InviteModal from "./InviateModal";
import { motion, AnimatePresence } from "framer-motion";
import { Edit2, Mail } from "lucide-react";

interface ModifyMemberModalProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
  onUpdate: (email: string) => void;
  onDelete: () => void;
  loading: boolean;
  errorMessage: string;
}

const ModifyMemberModal = ({ isOpen, onClose, email, onUpdate, onDelete, loading, errorMessage }: ModifyMemberModalProps) => {

  const [newEmail, setNewEmail] = useState(email);
  return (
    <InviteModal
      isOpen={isOpen}
      onClose={onClose}
      icon={<Edit2 size={20} />}
      title=" EDIT MEMBER"
      size="lg"
      footerChildren={
        <>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onUpdate(newEmail)}
            disabled={loading}
            className="px-4 py-2 text-white bg-sky-600 rounded-lg hover:bg-sky-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
          >
            Aggiorna
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={onDelete}
            className="px-4 py-2 text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
          >
            Elimina
          </motion.button>
        </>
      }
    >

      <div className="space-y-4 min-w-[450px]">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <Mail size={20} className="mr-1" />
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
          </div>
          <input
            type="email"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            placeholder="Aggiorna Email dell'Utente..."
          />
        </div>

        {/* Error Message */}
        <AnimatePresence>
          {errorMessage && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              className="text-red-500 text-sm bg-red-50 p-3 rounded-lg"
            >
              {errorMessage}
            </motion.div>
          )}
        </AnimatePresence>
      </div>

    </InviteModal>
  );
};

export default ModifyMemberModal;